import Box from '@mui/material/Box';
import { SxProps } from '@mui/system/styleFunctionSx';
import { Text } from 'components/Text';
import { Layout } from 'modules/minimal-ui-theme';
import { CvSuccessAnimation } from './CvSuccessAnimation';
import { CvSuccessTimeline, CvTimelineStep } from './CvSuccessTimeline';

const layoutStyles: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  minHeight: '80vh',
  gap: 3
};

interface Props {
  title: string;
  description1: string;
  description2: string;
  /**
   * What happens after submitting, as an ordered status timeline. Optional so the screen
   * still renders for callers that only have copy.
   *
   * Submitting a CV is not the end of the talent's process — an operator reads it, may
   * polish the wording, and then suggests the talent to the partner company, which decides
   * on an interview. Saying so is what turns a dead end into an expectation the talent can
   * hold, and it needs no invented SLA: it's the process the intro already described.
   */
  timeline?: CvTimelineStep[];
}

/**
 * The shared terminal screen shown after a CV is submitted — same treatment for the
 * authenticated and guest flows (only the copy differs). Plays the on-brand success
 * animation once, with the localized copy beneath.
 */
export const CvSuccessScreen = ({
  title,
  description1,
  description2,
  timeline
}: Props) => (
  <Layout childrenStyles={layoutStyles}>
    <CvSuccessAnimation />
    <Box
      sx={{
        maxWidth: 460,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1
      }}
    >
      <Text variant="h4">{title}</Text>
      <Text>{description1}</Text>
      <Text>{description2}</Text>
      {timeline && timeline.length > 0 && (
        <CvSuccessTimeline steps={timeline} />
      )}
    </Box>
  </Layout>
);
